import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, QuestionMarkCircleIcon, DocumentTextIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Support = () => {
  const faqs = [
    {
      question: 'Como começar a usar a plataforma?',
      answer: 'Clique em "Entrar no Sistema" na página inicial. Você será direcionado para o dashboard onde pode começar a cadastrar pacientes e exames imediatamente.',
    },
    {
      question: 'A plataforma está em conformidade com a NR-7?',
      answer: 'Sim! Nossa plataforma implementa todos os critérios da NR-7 e Portaria 19/98 do Ministério do Trabalho para análise de audiometrias ocupacionais.',
    },
    {
      question: 'Como funciona a análise de nexo causal?',
      answer: 'Nossa IA analisa o histórico audiométrico, dados ocupacionais, exposição a ruído e outros fatores para determinar o nexo causal em 4 níveis: provável, possível, indeterminado ou improvável.',
    },
    {
      question: 'Os laudos são válidos legalmente?',
      answer: 'Sim. Os laudos são gerados com fundamentação técnica e legal, mas sempre devem ser revisados e assinados por profissional habilitado conforme legislação vigente.',
    },
    {
      question: 'Posso exportar os dados?',
      answer: 'Sim! Você pode exportar exames, laudos e relatórios em PDF e CSV através do dashboard.',
    },
    {
      question: 'Como funciona o suporte técnico?',
      answer: 'Oferecemos suporte via e-mail, chat e documentação online. Usuários premium têm acesso a suporte prioritário com resposta em até 4 horas.',
    },
  ];

  const resources = [
    {
      icon: <DocumentTextIcon className="w-8 h-8 text-medical-600" />,
      title: 'Documentação',
      description: 'Guias completos sobre todas as funcionalidades da plataforma.',
      link: '#docs',
    },
    {
      icon: <QuestionMarkCircleIcon className="w-8 h-8 text-health-600" />,
      title: 'FAQ',
      description: 'Perguntas frequentes e respostas rápidas.',
      link: '#faq',
    },
    {
      icon: <ChatBubbleLeftRightIcon className="w-8 h-8 text-tech-600" />,
      title: 'Fale Conosco',
      description: 'Entre em contato direto com nosso time de suporte.',
      link: '/contact',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center text-medical-600 hover:text-medical-700 mb-8">
          <HomeIcon className="w-5 h-5 mr-2" />
          Voltar para Home
        </Link>

        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gradient">Central de Suporte</h1>
          <p className="text-xl text-gray-600">
            Encontre respostas rápidas ou entre em contato conosco
          </p>
        </div>

        {/* Resources Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {resources.map((resource, index) => (
            <Link
              key={index}
              to={resource.link}
              className="card-gradient hover:scale-105 transition-transform"
            >
              <div className="mb-4">{resource.icon}</div>
              <h3 className="text-xl font-bold mb-2 text-gray-800">{resource.title}</h3>
              <p className="text-gray-600">{resource.description}</p>
            </Link>
          ))}
        </div>

        {/* FAQ Section */}
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" id="faq">
          <h2 className="text-3xl font-bold mb-8 text-gray-800">Perguntas Frequentes</h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b border-gray-200 pb-6 last:border-0">
                <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-start">
                  <span className="text-medical-600 mr-2">Q:</span>
                  {faq.question}
                </h3>
                <p className="text-gray-600 ml-6 leading-relaxed">
                  <span className="text-health-600 font-semibold mr-2">A:</span>
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-gradient-to-r from-medical-600 to-tech-600 rounded-xl shadow-lg p-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">Não encontrou o que procurava?</h2>
          <p className="text-lg mb-6 opacity-90">
            Nossa equipe está pronta para ajudar você
          </p>
          <Link to="/contact" className="btn-outline">
            Entre em Contato
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Support;
